<template>
    <a :href="teamUrl">{{ team.name }}</a>
</template>

<script>
import Team from '../../js/dto/Team';

export default {
    name: 'KgrTeamNameLink',
    props: {
        team: Team,
        required: true,
    },
    computed: {
        teamUrl() {
            return `/backend/clubs/teams/${this.team.id}/basicData`;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    a {
    text-decoration: underline;
}
</style>
